module.exports = __webpack_public_path__ + "static/logo-c3323aed0ef056e87cbe9e2cfd027467.svg";